export const TOAST_ANNOUNCEMENT_BURST_WINDOW_MS = 1000;
export const TOAST_ANNOUNCEMENT_SET_DELAY_MS = 50;
